(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/dialogs/swish-dialogs.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/dialogs/swish-dialogs.js');

'use strict';

const _svs$accountservicesR = svs.accountservicesReact.deposit.dialogs.sharedDialogs,
  getDepositErrorMessage = _svs$accountservicesR.getDepositErrorMessage,
  showDepositSuccess = _svs$accountservicesR.showDepositSuccess;
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const getTrackingPaymentType = svs.accountservicesReact.deposit.tracking.sharedTracking.getTrackingPaymentType;
const logger = svs.accountservicesReact.deposit.swish.logger;


const getReturnUrl = () => {
  const userAgentFamily = navigator.userAgent.toLowerCase();
  let returnUrl;
  if (svs.core.detect.browser.crios()) {
    if (window.location.protocol.indexOf('s') > -1) {
      returnUrl = 'googlechromes://';
    } else {
      returnUrl = 'googlechrome://';
    }
  } else if (svs.core.detect.os.iOS()) {
    if (svs.core.config.data.svsconfig.isNativeApp) {
      returnUrl = window.location.href.replace(/https?/i, 'spelbutiken.bankid');
    } else if (userAgentFamily.indexOf('firefox') > -1) {
      returnUrl = "firefox://open-url?url=".concat(encodeURIComponent(encodeURIComponent(encodeURIComponent(svs.utils.url.currentUrlEncodedParams()))));
    } else if (userAgentFamily.indexOf('safari') > -1) {
      returnUrl = svs.utils.url.currentUrlEncodedParams();
    } else {
      returnUrl = 'null'; 
    }
  } else {
    returnUrl = 'null';
  }
  return returnUrl;
};
const getSwishAppURI = paymentRequestToken => {
  svs.utils.url.refreshQueryString();
  logger.debug("paymentRequestToken: ".concat(paymentRequestToken));
  if (paymentRequestToken) {
    const callbackUrl = encodeURIComponent(getReturnUrl());
    return "swish://paymentrequest?token=".concat(encodeURIComponent(paymentRequestToken), "&callbackurl=").concat(callbackUrl);
  }
  return 'swish://';
};
const showCancelSwish = () => {
  const dialogInfo = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    convertToPopup: false,
    autoClose: false,
    allowDimmerClick: false,
    icon: 'deposit',
    type: svs.ui.dialog.type.ERROR,
    title: 'Insättning med Swish avbruten',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: 'Det kan ta några minuter innan du kan starta en ny insättning.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: 'Vill du starta eller slutföra din insättning direkt? Öppna Swish-appen och klicka på godkänn eller avbryt. ' + 'Du behöver även ladda om sidan för att se uppdaterat saldo om du väljer att genomföra insättningen.'
    }],
    actions: [{
      type: svs.ui.dialog.button.SECONDARY,
      title: 'Stäng',
      callback() {
        dialogInfo.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialogInfo);
};
const showSwishTransferMobile = (onCancel, paymentRequestToken) => {
  svs.utils.url.navigate(getSwishAppURI(paymentRequestToken));
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'deposit',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    allowDimmerClick: false,
    title: 'Insättning med Swish',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: 'Väntar på att Swish-appen ska starta.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: 'Startar den inte, var vänlig starta den manuellt.'
    }],
    actions: [{
      type: svs.ui.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        onCancel();
      }
    }, {
      title: 'Starta Swish',
      showLoader: true,
      callback: () => {
        svs.utils.url.navigate(getSwishAppURI(paymentRequestToken));
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showSwishTransferDesktop = (onCancel, depositData, hasCellPhoneChangeBeforeSwishDeposit) => {
  const phoneInfo = hasCellPhoneChangeBeforeSwishDeposit ? "Mobilnummer f\xF6r Swish: ".concat(depositData.cellPhone) : "Registrerat mobilnummer f\xF6r Swish: ".concat(depositData.cellPhone, ".");
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'deposit',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    convertToPopup: false,
    autoClose: false,
    allowDimmerClick: false,
    title: 'Insättning med Swish',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: 'Starta din Swish-app på din mobil.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: phoneInfo
    }],
    actions: [{
      type: svs.ui.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        onCancel();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};

const showTransferError = (err, amount, handleSelect, maxLimitLeft) => new Promise(resolve => {
  const errorObject = getDepositErrorMessage(err, paymentTypes.SWISH, maxLimitLeft);
  const trackChangePaymentDialog = (accepted, paymentMethod) => {
    const track = {
      category: 'Deposits',
      action: "Swish failed use ".concat(getTrackingPaymentType(paymentMethod)),
      opt_label: accepted ? 'Accepted' : 'Rejected'
    };
    svs.components.analytics.trackEvent(track);
  };
  const swishOptionalDialog = () => {
    let paymentMethod = paymentTypes.BANKCARD;
    const isShowApplePay = svs.core.detect.browser.safari() && (svs.core.detect.os.iOS() || svs.core.detect.os.osX());
    if (isShowApplePay) {
      paymentMethod = paymentTypes.APPLEPAY;
    }
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'deposit',
      title: "Vill du g\xF6ra en ins\xE4ttning med ".concat(isShowApplePay ? 'Apple Pay' : 'bankkort', " ist\xE4llet?"),
      actions: [{
        title: 'Nej tack',
        callback() {
          const instantPay = {
            isPay: false
          };
          handleSelect(paymentTypes.SWISH, instantPay);
          trackChangePaymentDialog(false, paymentMethod);
          dialog.close();
        }
      }, {
        title: 'Ja det vill jag',
        callback() {
          const instantPay = {
            amount,
            isPay: true
          };
          handleSelect(paymentMethod, instantPay);
          trackChangePaymentDialog(true, paymentMethod);
          dialog.close();
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  if (errorObject.showKycError) {
    svs.core.module.load('/cl/components/kyc-messages', null, () => {
      svs.components.kyc_messages.showKYCMessage();
    });
  } else {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      area: svs.ui.dialog.area.POPUP,
      type: svs.ui.dialog.type.ERROR,
      allowDimmerClick: false,
      title: errorObject.dialogTitle,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: errorObject.dialogText
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          dialog.close();
          if (errorObject.showChangeDeposit) {
            swishOptionalDialog();
          }
          resolve();
        }
      }]
    });
    svs.ui.dialog.api.close();
    svs.ui.dialog.api.add(dialog);
  }
});

const showMobileNumberInfo = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    allowDimmerClick: true,
    icon: 'mobile',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.DEFAULT,
    title: 'Vi använder ditt mobilnummer för att:',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "<ul><li>Kunna ringa dig vid st\xF6rre vinst</li>\n          <li>F\xF6ra \xF6ver pengar genom en betaltj\xE4nst</li>\n          <li>Kunna skicka information och erbjudanden via sms (direktmarknadsf\xF6ring)</li>\n          <li>Kontakta dig vid behov, t.ex. av legala sk\xE4l</li></ul>\n          <div>Du kan hantera ditt mobilnummer och val f\xF6r direktmarknadsf\xF6ring under Min profil.</div>",
      align: svs.ui.dialog.message.align.LEFT
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});

const showCellPhoneVerifiedDialog = function (isNewCellphoneNumber) {
  let hasNoProfileLinkSwish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(resolve => {
    const dialog = new svs.ui.dialog.Confirm({
      icon: 'my-settings',
      branding: svs.ui.dialog.branding.TUR,
      area: svs.ui.dialog.area.POPUP,
      title: isNewCellphoneNumber ? 'Mobilnummer sparat' : 'Mobilnummer uppdaterat',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: "Ditt mobilnummer verifieras och ".concat(isNewCellphoneNumber ? 'sparas' : 'uppdateras', " f\xF6r smidigare ins\xE4ttning och uttag.")
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: "Inst\xE4llningar f\xF6r mobilnummer och direktmarknadsf\xF6ring kan hanteras under\n          ".concat(hasNoProfileLinkSwish ? 'Min profil' : "<a href=\"".concat(svs.core.urlMapping.get('myProfileHome'), "/uppgifter\">Min profil</a>."))
      }],
      actions: [{
        title: 'Okej',
        callback(e) {
          dialog.close(e);
          resolve();
        }
      }]
    });
    svs.ui.dialog.api.close();
    svs.ui.dialog.api.add(dialog);
  });
};
svs.accountservicesReact.deposit.dialogs.swishDialogs = {
  showSwishTransferMobile,
  showCancelSwish,
  showSwishTransferDesktop,
  showTransferError,
  showDepositSuccess,
  showCellPhoneVerifiedDialog,
  showMobileNumberInfo
};

 })(window);